import { BASE_URL } from './Config.js';

export class ExportService {
  
  exportTVA = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/export/tva`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Erreur lors de l\'export TVA');
      return await response.blob();
    } catch (error) {
      console.error('Error exporting TVA:', error);
      throw error;
    }
  };

  exportProducts = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/export/products`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Erreur lors de l\'export des produits');
      return await response.blob();
    } catch (error) {
      console.error('Error exporting products:', error);
      throw error;
    }
  };

  exportInventory = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/export/inventory`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Erreur lors de l\'export de l\'inventaire');
      return await response.blob();
    } catch (error) {
      console.error('Error exporting inventory:', error);
      throw error;
    }
  };
}